<template>
  <template v-if="documents.length > 0">
    <h4>{{ $t("configurator.form.labels.how_to_order_graphics") }}</h4>

    <div style="display: flex; flex-wrap: wrap; align-items: flex-start;" class="mt-3">
      <template v-for="document in documents" :key="document.id">
        <button type="button" class="btn btn-sm btn-primary margin-auto" @click="download(document)">
          <em class="fa fa-download"></em> {{ document.name }}
        </button>
      </template>
    </div>
  </template>
</template>

<script setup>
import { useMainStore } from '@/store';
import { downloadFile } from '@/utils/file';
import { computed } from 'vue';

const store = useMainStore()
// computed props
const documents = computed(() => {
  return store.tmp.instructions.filter((instruction) => {
    return instruction.language === store.settings.locale
  })
})

// define methods
const download = async (document) => {
  await downloadFile(
    '/api/shop/' + store.tmp.exhibition_slug + '/download/' + document.identifier,
    document.name + '.' + document.extension
  )
}
</script>